import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/components/Login.vue'
import CondoDashboard from '@/components/CondoDashBoard.vue'
import WhatsApp from '@/components/Whatsapp.vue'
import Cadastro from '@/components/Cadastro.vue'
import AllUser from '@/components/AllUser.vue'
import Agenda from '@/components/Agenda.vue'
import WhatsppLayout from '@/components/WhatsppLayout.vue'
import Config from '@/components/Config.vue'
import Ticket from '@/components/Ticket.vue'
import Files from '@/components/Files.vue'
import Transfer from '@/components/Transfer.vue'
import ConfigWhatsapp from '@/components/ConfigWhatsapp.vue'
import SiconGPT from '@/components/SiconGPT.vue'
import Financer from '@/components/Financer.vue'

const routes = [
  {
    path: '/cadastro',
    name: 'Cadastro',
    component: Cadastro
  },
  {
    path: '/financer',
    name: 'Financer',
    component: Financer,
    meta: { requiresAuth: true }
  },
  {
    path: '/config-wpp',
    name: 'ConfigWpp',
    component: ConfigWhatsapp
  },
  {
    path: '/config',
    name: 'Config',
    component: Config,
    meta: { requiresAuth: true }
  },
  {
    path: '/ticket',
    name: 'Ticket',
    component: Ticket,
    meta: { requiresAuth: true }
  },
  {
    path: '/tarefas',
    name: 'Agenda',
    component: Agenda,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios',
    name: 'AllUser',
    component: AllUser,
    meta: { requiresAuth: true }
  },

  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'CondoDashBoard', 
    component: CondoDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/whatsapp',
    name: 'WhatsApp',
    component: WhatsApp,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'WhatsppLayout',
    component: WhatsppLayout,
    meta: { requiresAuth: true }
  },
  {
    path: '/files',
    name: 'Files',
    component: Files,
    meta: { requiresAuth: true }
  },
  {
    path: '/transfer',
    name: 'Transfer',
    component: Transfer,
    meta: { requiresAuth: false }

  },
  {
    path: '/sicon-gpt',
    name: 'SiconGPT',
    component: SiconGPT
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: () => import('@/components/AccessDanied.vue'),
    props: route => ({ requiredPermission: route.params.requiredPermission })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('authToken')
  if (to.meta.requiresAuth && !token) {
    return next({ name: 'Login' })
  }
  next()
})

export default router
